import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { ToolbarModel, ToolbarModelPlus } from "./toolbar.model";

@Injectable({
  providedIn: "root",
})
export class ToolbarService {
  private toolbarButtonSource = new Subject<ToolbarModel>();
  private toolbarItemUpdateSource = new Subject<ToolbarModel>();
  private toolbarChangeSource = new Subject<ToolbarModelPlus>();
  private toolbarVisibilitySource = new Subject<boolean>();
  private toolbarResetSource = new Subject<boolean>();
  private toolbarFavouriteCardSource = new BehaviorSubject<boolean>(true);
  private toolbarFavouriteCardLeftAlignedSource = new BehaviorSubject<boolean>(
    true
  );

  isToolbarChanged = this.toolbarChangeSource.asObservable();
  isVisibilityChanged = this.toolbarVisibilitySource.asObservable();
  isToolbarReset = this.toolbarResetSource.asObservable();
  isToolbarItemUpdated = this.toolbarItemUpdateSource.asObservable();

  isButtonClicked = this.toolbarButtonSource.asObservable();
  isFavouriteCardShown = this.toolbarFavouriteCardSource.asObservable();
  isFavouriteCardLeftAligned =
    this.toolbarFavouriteCardLeftAlignedSource.asObservable();

  clickButton(toolbarModel: ToolbarModel) {
    console.log("clickButton", toolbarModel);
    this.toolbarButtonSource.next(toolbarModel);
  }

  setToolbar(
    items: ToolbarModel[],
    clearList: boolean = false,
    showFavouriteCard: boolean = true
  ) {
    //console.log(items)
    this.toolbarChangeSource.next({ buttons: items, clearList: clearList });
    this.toolbarFavouriteCardSource.next(showFavouriteCard);
    this.toolbarFavouriteCardLeftAlignedSource.next(false);
  }

  updateToolbarItem(item: ToolbarModel) {
    this.toolbarItemUpdateSource.next(item);
  }

  setFavouriteCardLeftAligned(isLeftAligned: boolean) {
    this.toolbarFavouriteCardLeftAlignedSource.next(isLeftAligned);
  }

  hideToolbar() {
    this.toolbarVisibilitySource.next(false);
  }

  showToolbar() {
    this.toolbarVisibilitySource.next(true);
  }

  resetToolbar(
    makeEmpty: boolean = false,
    showFavouriteButton: boolean = true
  ) {
    this.toolbarResetSource.next(makeEmpty);
    this.toolbarFavouriteCardSource.next(showFavouriteButton);
  }
}
